import req from '@/request.js'
import tenant from '@/store/tenant'
import utils from '@/eco-ui-util.js'
import { Promise } from 'q'
const portal = req.getContext().portal
const third = req.getContext().third
const uc = req.getContext().uc
export default {
  getSysCat() {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysType/v1/sysTypeTree').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  GETALLDATADICT(cb) {
    req.post(`${portal}/sys/dataDict/v1/getAll`, {}).then((response) => {
      cb(response)
    })
  },
  GETALLENUMSLIST(cb) {
    req.get(`${portal}/sys/list_config/getAllEnums`, {}).then((response) => {
      cb(response)
    })
  },
  getSysCatByPage(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/category/v1/list', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  getMenus() {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/sysMenu/v1/getCurrentUserMenu?menuAlias=manage_menu`).then(
        (response) => {
          resolve(response.data.value)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  removeMenuById(id) {
    return new Promise((resolve, reject) => {
      req.remove(`${portal}/sys/sysMenu/v1/remove?id=${id}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getMenuTree() {
    let ignoreAlias = ''
    if (tenant.state.tenantId) {
      ignoreAlias = '?ignoreAlias=tenant'
    }
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/sysMenu/v1/getTree${ignoreAlias}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getMenuTreeByI18n() {
    let ignoreAlias = ''
    if (tenant.state.tenantId) {
      ignoreAlias = '?ignoreAlias=tenant'
    }
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/sysMenu/v1/getTreeI18n${ignoreAlias}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getMenuTreeByParentId(params) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/sysMenu/v1/getTreeByParentId?id=${params.parentId}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getMenuByRoleAlias(roleAlias) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/sysMenu/v1/getMenuByRoleAlias?roleAlias=` + roleAlias).then(
        (response) => {
          resolve(utils.tile2nest(response.data))
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  delSysType(id) {
    return new Promise((resolve, reject) => {
      req.remove(`${portal}/sys/sysType/v1/remove?id=${id}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //附件在线预览
  onlinePreview(id, cb) {
    req.get(portal + '/file/onlinePreviewController/v1/onlinePreview?fileId=' + id).then((response) => {
      cb(response)
    })
  },
  //附件下载
  downloadFile(id, cb) {
    req.download(portal + '/system/file/v1/downloadFile?fileId=' + id)
  },
  //流水号列表
  getIdentityPageJson(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/identity/v1/listJson', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getIdentityPageQuery(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + "/sys/identityRecord/v1/query", param).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getSysExternalUnitePageJson(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/portal/sysExternalUnite/v1/listJson', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  delSysExternalUniteById(id) {
    return new Promise((resolve, reject) => {
      req.remove(portal + `/portal/sysExternalUnite/v1/removes?ids=` + id).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  syncUser(id) {
    return new Promise((resolve, reject) => {
      req.get(portal + `/portal/sysExternalUnite/v1/syncUser?id=` + id).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  pullUser(id) {
    return new Promise((resolve, reject) => {
      req.get(portal + `/portal/sysExternalUnite/v1/pullUser?id=` + id).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  generateMenuUrl(id) {
    return new Promise((resolve, reject) => {
      req.get(portal + `/portal/sysExternalUnite/v1/generateMenuUrl?id=` + id).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  //数据源列表
  getDataSourcePageJson(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysDataSource/v1/listJson', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //测试数据源连接
  checkConnection(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysDataSource/v1/checkConnection', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //定时计划列表
  getschedulerPageJson(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/job/scheduler/v1/jobList', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //切换定时计划状态
  changeStart(isStandby) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/job/scheduler/v1/changeStart?isStandby=' + isStandby).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //删除定时计划
  delJob(jobName) {
    return new Promise((resolve, reject) => {
      req.remove(portal + '/job/scheduler/v1/delJob?jobName=' + jobName).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //定时计划日志列表
  getSchedulerPageJsonbyJobName(url, param) {
    return new Promise((resolve, reject) => {
      req.post(url, param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //定时计划触发器列表
  getTriggersJsonByJob(url, param) {
    return new Promise((resolve, reject) => {
      req.post(url, param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //定时计划禁用触发器
  toggleTriggerRun(triggerName) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/job/scheduler/v1/toggleTriggerRun?name=' + triggerName).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //定时计划删除触发器
  delTrigger(triggerName) {
    return new Promise((resolve, reject) => {
      req.remove(portal + '/job/scheduler/v1/delTrigger?name=' + triggerName).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //国际化资源管理列表
  getI18nMessageTypePageJson(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/i18n/custom/i18nMessageType/v1/list', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }, //查询所有语种类型
  geti18nMessageTypeAll() {
    return new Promise((resolve, reject) => {
      req.post(portal + '/i18n/custom/i18nMessageType/v1/all').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //国际化资源判断类型是否存在
  getI18nMessageTypeByType(type) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/i18n/custom/i18nMessageType/v1/getByType?type=' + type).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //国际化资源判断key是否存在
  getByMessKey(key) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/i18n/custom/i18nMessage/v1/getByMessKey?key=' + key).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //删除国际化资源
  i18nMessageDelByKey(key) {
    return new Promise((resolve, reject) => {
      req.remove(portal + `/i18n/custom/i18nMessage/v1/delByKey?key=` + key).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取国际化资源
  getI18nMessagePageJson(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/i18n/custom/i18nMessage/v1/list', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //初始化国际化资源
  i18nMessageInit() {
    return new Promise((resolve, reject) => {
      req.post(portal + '/i18n/custom/i18nMessage/v1/init').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //清除缓存
  i18nMessageClearCache() {
    return new Promise((resolve, reject) => {
      req.post(portal + '/i18n/custom/i18nMessage/v1/clearCache').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //根据分类id获取字典
  getByTypeId(typeId) {
    return new Promise((resolve, reject) => {
      req.post(`${portal}/sys/dataDict/v1/getByTypeId`, typeId).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //根据分类key获取字典
  getByTypeKey(typeKey) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/dataDict/v1/getByTypeKey?typeKey=${typeKey}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //根据数据字典id 删除数据
  delDataDict(id) {
    return new Promise((resolve, reject) => {
      req.remove(`${portal}/sys/dataDict/v1/invalid?id=${id}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //删除数据字典根类型
  delDataTypeDict(id) {
    return new Promise((resolve, reject) => {
      req.remove(`${portal}/sys/sysType/v1/invalid?id=${id}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取布局
  getIndexLayoutPage(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/portal/sysIndexLayout/sysIndexLayout/v1/listJson', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取布局
  getIndexColumnPage(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/portal/sysIndexColumn/sysIndexColumn/v1/listJson', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //添加汇报线
  addUserRel(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/api/userRel/v1/userRel/addUserRel', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //修改汇报线
  updateUserRel(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/api/userRel/v1/userRel/updateUserRel', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteUserRel(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/api/userRel/v1/userRel/deleteUserRel', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取布局管理列表
  getLayoutManagerPage(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/listJson', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取布局管理列表
  getLayoutManageDesignData(id, layoutType) {
    return new Promise((resolve, reject) => {
      req.get(portal + `/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/design?id=${id}&layoutType=${layoutType}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取首页布局
  getHomeLayout() {
    return new Promise((resolve, reject) => {
      req.get(portal + '/portal/main/v1/myHome').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getColumnByAlias(alias) {
    return new Promise((resolve, reject) => {
      req.get(portal + '/portal/sysIndexColumn/sysIndexColumn/v1/getByAlias?alias=' + alias).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteOrg(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/api/org/v1/org/deleteOrg', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getDefaultLayoutManagerPage(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/getSysDefaultLayout', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  setlayoutMngShareToSub(id, shareToSub) {
    return new Promise((resolve, reject) => {
      req.get(portal + `/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/setShareToSub?id=${id}&shareToSub=${shareToSub}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  setlayoutMngEnable(id, enable) {
    return new Promise((resolve, reject) => {
      req.get(portal + `/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/enable?id=${id}&enable=${enable}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getLayoutMngById(id) {
    return new Promise((resolve, reject) => {
      req.get(portal + '/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/getJson?id=' + id).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getCurrentMenu() {
    return new Promise((resolve, reject) => {
      req.get(portal + '/sys/sysMenu/v1/getCurrentUserMenu?menuAlias=front_menu').then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取用户头像
  downloadImg(fileId, cb) {
    req.get(window.context.portal + '/system/file/v1/preview?fileId=' + fileId, 'blob').then(
      (response) => {
        if (response.data.size > 0) {
          var blob = response.data
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            cb(e.target.result)
          }
        } else {
          cb('')
        }
      },
      function errorCallback() {
        cb('')
      }
    )
  },
  getCurrentMenuByAlias(menuAlias) {
    return new Promise((resolve, reject) => {
      req.get(portal + '/sys/sysMenu/v1/getCurrentUserMenu?menuAlias=' + menuAlias).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  saveDataTemplateToMenu(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysMenu/v1/addDataTemplateToMenu', param).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  isMenuExist(alias) {
    return new Promise((resolve, reject) => {
      req.get(portal + '/sys/sysMenu/v1/isMenuExistByAlias?alias=' + alias).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getSysProperties(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysProperties/v1/listJson', param).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getSysProperty(id) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/sysProperties/v1/getJson?id=${id}`).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getSysModuleJson(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysModule/v1/listJson', param).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getDefaultPwdStrategy() {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/sys/sysPwdStrategy/v1/getDefault`).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getDefPwdStrategy(cb) {
    req.get(portal + '/sys/sysPwdStrategy/v1/getDefault').then((response) => {
      cb(response.data)
    })
  },
  saveDefaultPwdStrategy(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysPwdStrategy/v1/save', param).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  importDataDict(param, typeId) {
    return new Promise((resolve, reject) => {
      req.post(portal + `/sys/dataDict/v1/import?typeId=${typeId}`, param).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //保存方法数据信息
  saveAction(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/sys/sysAction/v1/save', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //更新方法数据信息
  updateAction(param) {
    return new Promise((resolve, reject) => {
      req.put(portal + '/sys/sysAction/v1/update', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getActionDetail(id) {
    return new Promise((resolve, reject) => {
      req.get(portal + '/sys/sysAction/v1/' + id).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteAction(id) {
    return new Promise((resolve, reject) => {
      req.remove(portal + '/sys/sysAction/v1/remove?id=' + id).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getTenantBankInfo(id) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/system/tenant_bank_info/${id}`).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getCompanyInfo(id) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/system/tenant_bank_info/getDefaultBankInfoByCorporateId?corporateId=${id}`).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getTenantCorporateInfo(id) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/system/tenant_corporate_info/${id}`).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getTenantCorporateQrCode(id) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/system/tenant_corporate_info/${id}/qr`).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getRoleLayouts(roleCode, queryFilter) {
    return new Promise((resovle, reject) => {
      req
        .request({
          url: `${portal}/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/role/getRoleLayouts`,
          data: queryFilter,
          method: 'POST',
          params: { code: roleCode },
          dataType: 'json'
        })
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },
  getSysNcConfig(param) {
    return new Promise((resolve, reject) => {
      req.post(third + '/third_financial_mapping/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getSysNcTemplate(param) {
    return new Promise((resolve, reject) => {
      req.post(third + '/third_document_template/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //根据分类key获取字典
  getCostAccountById(params) {
    let url = params ? `${third}/cost_account/getById${req.formatGetUri(params)}` : `${third}/cost_account/getById?id=0`
    return new Promise((resolve, reject) => {
      req.get(url).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //微信同步-用户接口
  getWxUserListByOrgId(orgId, type) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/portal/sysExternalUnite/v1/getUserListByOrgId?orgId=` + orgId + '&type=' + type).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //微信同步-组织接口
  getWxOrgList(type) {
    return new Promise((resolve, reject) => {
      req.get(`${portal}/portal/sysExternalUnite/v1/getOrgList?type=` + type).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 流程路由分页
  getFlowRouterList(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/process_routing/query`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 流程路由更新
  getUpdateFlowRouter(params) {
    return new Promise((resolve, reject) => {
      req.put(`${third}/process_routing/`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 流程路由添加
  getUpdateFlowRouterAdd(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/process_routing/`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 流程路由删除
  getUpdateFlowRouterDel(params) {
    return new Promise((resolve, reject) => {
      req.remove(`${third}/process_routing/${params.id}`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 新筑同步用户
  xzSyncUser(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/data_sync/syncUserByList`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 新筑同步岗位
  xzSyncJob(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/data_sync/syncJob`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 新筑同步职位
  xzSyncPos(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/data_sync/syncPos`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 新筑同步组织
  xzSyncOrg(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/data_sync/syncOrg`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  yzhSyncOrgManual(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/ldap/sync?demId=${params}`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
   yzhSyncOrg(demId,params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/ldap/setSyncRule?demId=${demId}`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 新筑配置验证码
  sendCodeByMobile(tenantId, mobile) {
    return new Promise((resolve, reject) => {
      req.get(`${third}/common/sendCodeByMobile?tenantId=${tenantId}&mobile=${mobile}`).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取水印配置列表
  getWaterMarkAll(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/watermark/setting/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //应用水印配置
  saveWaterMarkForm(param, isAppend) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/watermark/setting/form?isAppend=' + isAppend, param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取应用绑定的表单列表
  getWaterMarkForms(waterMarkId) {
    return new Promise((resolve, reject) => {
      req.get(portal + '/watermark/setting/' + waterMarkId + '/form').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取表单绑定的水印
  getWaterMarkByFormKey(formKey) {
    return new Promise((resolve, reject) => {
      req.get(portal + '/watermark/setting/form/' + formKey).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 用友U8sequence
  getYongU8SourceList(params) {
    return new Promise((resolve, reject) => {
      req.post(`${third}/u8/data_source/getList`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取菜单额外配置
  getMenuExpandAll(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/portal_menu_expand/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //应用水印配置
  saveMenuExpandForm(param) {
    return new Promise((resolve, reject) => {
      req.post(portal + '/portal_menu_expand', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //获取合同审查合同类型
  getAiContractRuleType() {
    return new Promise((resolve, reject) => {
      req.get(portal + '/rule/portal_contract_rule/defaultList').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
}
